import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="w-full bg-black py-20 px-4" data-id="element-191">
      <div className="max-w-4xl mx-auto text-center" data-id="element-192">
        {/* Logo */}
        <div className="text-[#00E68A] text-3xl font-black tracking-widest mb-8" data-id="element-193">
          🌟 PROFEPACK
        </div>

        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3" data-id="element-194">
          El próximo domingo podés seguir buscando material en Google.
        </h2>
        <p className="text-[#00E68A] text-2xl sm:text-3xl font-black mb-10" data-id="element-195">
          O podés tener todo resuelto desde hoy.
        </p>

        {/* Countdown */}
        <div className="mb-4" data-id="element-196">
          <p className="text-white font-bold mb-4" data-id="element-197">
            ⏰ El precio de lanzamiento cierra en:
          </p>
          <CountdownTimer size="lg" blinking={true} data-id="element-198" />
        </div>
        <p className="text-gray-300 text-sm mb-12" data-id="element-199">
          Después sube{' '}
          <span className="text-[#FF0000] font-bold" data-id="element-200">$10.000 ARS</span> y no
          vuelve.
        </p>

        {/* 2 pricing cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10 max-w-3xl mx-auto" data-id="element-201">
          <div className="bg-[#0a0a0a] border border-white/20 rounded-xl p-6 text-center flex flex-col" data-id="element-202">
            <div className="text-3xl mb-3" data-id="element-203">📗</div>
            <h3 className="text-white font-black mb-2 text-lg" data-id="element-204">
              MEGAPACK SECUNDARIA
            </h3>
            <p className="text-gray-400 text-sm mb-4 flex-1" data-id="element-205">
              6 Tomos + 6 Bonos
            </p>
            <div className="text-gray-500 line-through text-sm mb-1" data-id="element-206">
              $53.000
            </div>
            <p className="text-[#00E68A] text-3xl font-black mb-6" data-id="element-207">
              $19.990 ARS
            </p>
            <a href="https://www.profepack.com/cart/48115364626688:1" className="btn-bordo-pulse block bg-white/10 text-white font-black py-4 rounded-lg hover:bg-white/20 transition-colors text-sm" data-id="element-208">
              → QUIERO MI MEGAPACK
            </a>
          </div>

          <div className="bg-[#0a100d] border-2 border-[#00E68A] rounded-xl p-6 text-center shadow-[0_0_30px_rgba(0,230,138,0.2)] flex flex-col relative" data-id="element-209">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#00E68A] text-gray-900 text-xs font-black px-3 py-1 rounded-full whitespace-nowrap" data-id="element-210">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="text-3xl mb-3" data-id="element-211">🏆</div>
            <h3 className="text-[#00E68A] font-black mb-2 text-lg" data-id="element-212">
              MEGAPACK + ADAPTACIONES
            </h3>
            <p className="text-gray-400 text-sm mb-4 flex-1" data-id="element-213">
              6 Tomos + 6 Bonos + Adaptaciones al Aula Real
            </p>
            <div className="text-gray-500 line-through text-sm mb-1" data-id="element-214">
              $69.000
            </div>
            <p className="text-[#00E68A] text-3xl font-black mb-6" data-id="element-215">
              $27.990 ARS
            </p>
            <a href="https://www.profepack.com/cart/48097187004672:1" className="btn-bordo-pulse block bg-[#00E68A] text-gray-900 font-black py-4 rounded-lg hover:bg-[#00CC7A] transition-colors text-sm" data-id="element-216">
              → QUIERO MEGAPACK + ADAPTACIONES
            </a>
          </div>
        </div>

        {/* Final trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-300" data-id="element-217">
          <span data-id="element-218">🔒 Pago 100% seguro</span>
          <span data-id="element-219">⚡ Acceso en 5 minutos</span>
          <span data-id="element-220">🛡️ Garantía 7 días sin preguntas</span>
          <span data-id="element-221">
            💳 Mercado Pago | Tarjeta de crédito | Transferencia bancaria
          </span>
        </div>
      </div>
    </section>;
}